"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import Loader from "@/Components/Loader/Loader";

const SimilarProductLinks = ({ products }) => {
  const router = useRouter();
  const [loadingProduct, setLoadingProduct] = useState(null);

  const handleNavigation = (product) => {
    setLoadingProduct(product.productAlias);
    
    // Add a small delay to ensure the loader is visible before navigation
    setTimeout(() => {
      router.push(`/products/${product.type}/${product.productAlias}`);
    }, 100);
  };

  return (
    <div className="space-y-1 pt-1">
      {products?.map((product) => {
        const isLoading = loadingProduct === product.productAlias;
        
        return (
          <div
            key={`product-${product.productAlias}`}
            onClick={() => handleNavigation(product)}
            className="flex items-center gap-2 cursor-pointer"
          >
            {isLoading ? (
              <>
                <div className="w-[48px] h-[48px] flex items-center justify-center">
                  <div className="w-6 h-6"><Loader /></div>
                </div>
                <div className="text-[14px] truncate-ellipsis min-w-[50px] text-[#4B4B4B] font-poppins font-medium">
                  {product?.openfda?.brand_name || 'Product Name'}
                </div>
              </>
            ) : (
              <>
                <Image
                  src={"/Images/placeholder_medicine.svg"}
                  width={48}
                  height={48}
                  className="aspect-square w-[48px] h-[48px]"
                  alt="medicine"
                />
                <div className="text-[14px] truncate-ellipsis min-w-[50px] text-[#4B4B4B] font-poppins font-medium">
                  {product?.openfda?.brand_name || 'Product Name'}
                </div>
              </>
            )}
          </div>
        );
      })}
      {/* Removed full-page Loader — causes stuck portal with Next.js soft navigation */}
    </div>
  );
};

export default SimilarProductLinks;
